export const BASE_ITEMS = [
  {
    id: "uploads",
    name: "Uploads",
  },
  {
    id: "templates",
    name: "Templates",
  },
  {
    id: "backgrounds",
    name: "Backgrounds",
  },
  {
    id: "text",
    name: "Text",
  },
  /* {
    id: "shapes",
    name: "Shapes",
  } */
]

export enum PanelType {
  UPLOADS = "Uploads",
  TEMPLATES = "Templates",
  BACKGROUND = "Background",
}
